import React, { Component } from "react";
import  PayrollMain  from "./PayrollMain";

export default class PayrollGenerate extends Component {

  render() {
    return <PayrollMain id={2} />;
  }
}
